import { useInView } from "react-intersection-observer";
import { useState, useEffect } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const LottieAnimation = ({ source, speed }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger only once when the element is in view
    threshold: 0.1, // Trigger when 10% of the element is visible
  });

  // Set a timeout to trigger animation after 3 seconds
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShouldRender(true);
    }, 8000); // 3000ms = 3 seconds

    // Cleanup timeout on component unmount
    return () => clearTimeout(timeout);
  }, []);

  // Set shouldRender to true if the element comes into view
  useEffect(() => {
    if (inView) {
      setShouldRender(true);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      className="mx-auto h-[250px] w-[250px] md:h-[350px] md:w-[350px]"
    >
      {/* Render the animation if in view or 3 seconds have passed */}
      {shouldRender && (
        <DotLottieReact src={source} autoplay loop speed={speed} />
      )}
    </div>
  );
};

export default LottieAnimation;
